import React, { Dispatch, ReactNode, createContext, useContext, useMemo, useReducer } from 'react';
import { initialInterventionCreationState, interventionCreationReducer } from './reducer';
import { InterventionCreationAction, InterventionCreationState } from './types';

type InterventionCreationContextType = {
  state: InterventionCreationState;
  dispatch: Dispatch<InterventionCreationAction>;
};

const InterventionCreationContext = createContext<InterventionCreationContextType | undefined>(
  undefined
);

export const useInterventionCreation = (): InterventionCreationContextType => {
  const context = useContext(InterventionCreationContext);

  if (context === undefined) {
    throw new Error(
      'useInterventionCreation must be used within an InterventionCreationContextProvider'
    );
  }

  return context;
};

export const InterventionCreationContextProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(
    interventionCreationReducer,
    initialInterventionCreationState
  );

  // dispatch est stable, seul state fait varier la valeur : la table de demandes
  // ne doit pas se re-rendre parce qu'un voisin a changé.
  const value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <InterventionCreationContext.Provider value={value}>
      {children}
    </InterventionCreationContext.Provider>
  );
};
